module.exports = __webpack_public_path__ + "img/logo_bp.06c44e39.jpg";